import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Divider from '@material-ui/core/Divider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import BaseDialog from '../../../../components/BaseDialog/BaseDialog';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'workRequests';

class SuggestionDialog extends React.Component {
  constructor(props) {
    super(props);
    this.generateContent = this.generateContent.bind(this);
  }

  generateContent() {
    const {
      classes,
      summary,
      details,
      expansionTitle,
      expansionContent,
    } = this.props;
    return (
      <React.Fragment>
        <Typography variant='body2' component='div' className={classes.summary}>
          {summary}
        </Typography>
        <Divider />
        <Typography variant='body2' component='div' className={classes.details}>
          {details}
        </Typography>
        <Divider />
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography variant='body2'>
              {expansionTitle}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <Typography variant='body2' component='div' className={classes.expansionContent}>
              {expansionContent}
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <Divider />
      </React.Fragment>
    );
  }

  render() {
    const {
      classes,
      open,
      icon,
      title,
      buttonAction,
      buttonLabel,
      secondaryButtonAction,
      secondaryButtonLabel,
    } = this.props;

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          title={title}
          content={this.generateContent()}
          buttonAction={buttonAction}
          buttonLabel={buttonLabel}
          secondaryButtonAction={secondaryButtonAction}
          secondaryButtonLabel={secondaryButtonLabel}
          icon={icon}
          contentWrap={false}
        />
      </div>
    );
  }
}

SuggestionDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  icon: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  expansionTitle: PropTypes.string.isRequired,
  expansionContent: PropTypes.object.isRequired,
  buttonAction: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  secondaryButtonAction: PropTypes.func.isRequired,
  secondaryButtonLabel: PropTypes.string.isRequired,
};

SuggestionDialog.defaultProps = {};

export default withStyles(styles)(SuggestionDialog);
